export { type Alignment } from './Headline';
export { default as Headline } from './Headline';
